import Filters from '../../components/filters/script';

const blocks = document.querySelectorAll('.block-filter-top');
if (blocks.length > 0) {
	blocks.forEach((block) => {
		const postsWrapper = block.querySelector(
			'.block-filter-top .block-filter-top__posts'
		);
		if (postsWrapper) {
			new Filters(block, postsWrapper);
		}
	});
}
document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.acf-map').forEach((mapEl) => {
		const zoom = parseInt(mapEl.dataset.zoom) || 14;
		const markers = mapEl.querySelectorAll('.marker');
		const bounds = new google.maps.LatLngBounds();

		// Filter markers with valid lat/lng
		const validMarkers = Array.from(markers).filter((markerEl) => {
			const lat = parseFloat(markerEl.dataset.lat);
			const lng = parseFloat(markerEl.dataset.lng);
			return !isNaN(lat) && !isNaN(lng);
		});

		if (validMarkers.length === 0) {
			mapEl.classList.add('inactive');
			return; // Skip initializing the map
		}

		const map = new google.maps.Map(mapEl, {
			zoom,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true,
		});

		validMarkers.forEach((markerEl) => {
			const lat = parseFloat(markerEl.dataset.lat);
			const lng = parseFloat(markerEl.dataset.lng);
			const latLng = new google.maps.LatLng(lat, lng);
			bounds.extend(latLng);

			const marker = new google.maps.Marker({
				position: latLng,
				map,
			});

			marker.addListener('click', () => {
				const url = `https://www.google.com/maps?q=${lat},${lng}`;
				window.open(url, '_blank');
			});
		});

		if (validMarkers.length === 1) {
			map.setCenter(bounds.getCenter());
			map.setZoom(zoom);
		} else {
			map.fitBounds(bounds);
		}
	});
});
